import React from "react";
import { motion } from "framer-motion";
import { MemoryRouter } from "react-router-dom";
import styles from "./Verifyx.module.scss";

// --- Centralized Inline SVGs ---
const Icons = {
  Check: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
  ),
  ArrowRight: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M5 12h14M12 5l7 7-7 7"></path>
    </svg>
  ),
  Workflow: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
      <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
    </svg>
  ),
  Visibility: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
    </svg>
  ),
  AI: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
    </svg>
  ),
  Mobile: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
    </svg>
  ),
  SLA: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
  ),
  Collab: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
    </svg>
  ),
  Lock: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
    </svg>
  ),
  Risk: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"></path>
    </svg>
  ),
  Impact: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
    </svg>
  ),
  Bank: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
    </svg>
  ),
  Network: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"></path>
    </svg>
  ),
  User: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
    </svg>
  ),
  File: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
    </svg>
  ),
  Document: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"></path>
    </svg>
  ),
  Globe: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M3.055 13H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064"></path>
    </svg>
  ),
  Server: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4"></path>
    </svg>
  ),
  Link: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
    </svg>
  ),
  Mic: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"></path>
      <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
      <line x1="12" x2="12" y1="19" y2="22"></line>
    </svg>
  ),
  Clipboard: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
    </svg>
  ),
  Shield: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  TrendingUp: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
      <polyline points="17 6 23 6 23 12"></polyline>
    </svg>
  ),
  CreditCard: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
      <line x1="1" y1="10" x2="23" y2="10"></line>
    </svg>
  ),
  Cloud: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
    </svg>
  ),
  PieChart: () => (
    <svg
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="1em"
      height="1em"
    >
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
    </svg>
  ),
};

// --- Animations ---
const parentVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.1 } },
};
const childVariants = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
  },
};

// --- Custom VerifyX Hero Art ---
const VerifyXHeroArt = () => (
  <div className="product-hero-art" aria-hidden>
    <div className="product-hero-art-glow" />
    <svg
      className="product-hero-svg"
      viewBox="0 0 400 360"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="hero-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="6" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="line-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4f46e5" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.2" />
        </linearGradient>
      </defs>

      {/* Network Connections */}
      <path
        d="M200 180 L100 100 M200 180 L300 100 M200 180 L100 260 M200 180 L300 260"
        stroke="url(#line-grad)"
        strokeWidth="2"
        strokeDasharray="4 4"
        className="anim-dash"
      />

      {/* Central Node */}
      <circle
        cx="200"
        cy="180"
        r="40"
        fill="rgba(79, 70, 229, 0.1)"
        stroke="#4f46e5"
        strokeWidth="2"
        className="anim-float"
      />
      <path
        d="M190 180 L197 187 L210 173"
        stroke="#4f46e5"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Satellite Nodes */}
      <rect
        x="70"
        y="80"
        width="60"
        height="40"
        rx="8"
        fill="rgba(14, 165, 233, 0.1)"
        stroke="#0ea5e9"
        strokeWidth="1.5"
        className="anim-float"
        style={{ animationDelay: "0.2s" }}
      />
      <text x="83" y="104" fill="#0ea5e9" fontSize="12" fontWeight="bold">
        Legal
      </text>

      <rect
        x="270"
        y="80"
        width="60"
        height="40"
        rx="8"
        fill="rgba(16, 185, 129, 0.1)"
        stroke="#10b981"
        strokeWidth="1.5"
        className="anim-float"
        style={{ animationDelay: "0.4s" }}
      />
      <text x="288" y="104" fill="#10b981" fontSize="12" fontWeight="bold">
        Tech
      </text>

      <rect
        x="70"
        y="240"
        width="60"
        height="40"
        rx="8"
        fill="rgba(245, 158, 11, 0.1)"
        stroke="#f59e0b"
        strokeWidth="1.5"
        className="anim-float"
        style={{ animationDelay: "0.6s" }}
      />
      <text x="88" y="264" fill="#f59e0b" fontSize="12" fontWeight="bold">
        CPV
      </text>

      <rect
        x="270"
        y="240"
        width="60"
        height="40"
        rx="8"
        fill="rgba(168, 85, 247, 0.1)"
        stroke="#a855f7"
        strokeWidth="1.5"
        className="anim-float"
        style={{ animationDelay: "0.8s" }}
      />
      <text x="288" y="264" fill="#a855f7" fontSize="12" fontWeight="bold">
        CPD
      </text>

      {/* Scanning Ring */}
      <circle
        cx="200"
        cy="180"
        r="80"
        stroke="#0ea5e9"
        strokeWidth="1"
        fill="none"
        opacity="0.5"
        className="anim-ping"
      />
    </svg>
  </div>
);

export default function VerifyX() {
  return (
    <>
      <div className="product-page">
        {/* 1. HERO SECTION */}
        <section className="product-hero-dark">
          <div className="product-hero-mesh" />
          <div className="product-hero-glow-1" />
          <div className="product-hero-glow-2" />

          <div className="sec-container">
            <div className="product-hero-row">
              <motion.div
                className="product-hero-inner"
                variants={parentVariants}
                initial="hidden"
                animate="show"
              >
                <motion.div
                  className="product-eyebrow"
                  variants={childVariants}
                >
                  <span className="product-eyebrow-dot" /> Simple · Transparent
                  · Secure
                </motion.div>
                <motion.h1 className="product-h1" variants={childVariants}>
                  <span className="product-text-gradient">Verification</span>{" "}
                  Workflows for BFSI Industry
                </motion.h1>
                <motion.p className="product-lead" variants={childVariants}>
                  Reduce NPAs, speed up turnaround time, and simplify
                  compliance—all in one platform for Technical, Legal, CPV &
                  CPD. AI-powered, SLA-driven, and mobile-enabled to make faster
                  credit decisions and build compliance into your everyday
                  process.
                </motion.p>
                <motion.div className="product-pills" variants={childVariants}>
                  <span className="product-pill product-pill-highlight">
                    Lower NPA risk
                  </span>
                  <span className="product-pill">AI & OCR</span>
                  <span className="product-pill">SLA control</span>
                  <span className="product-pill">Mobile field</span>
                  <span className="product-pill">DPDPA-ready</span>
                </motion.div>
                <motion.div
                  className="product-cta-group"
                  variants={childVariants}
                >
                  <a
                    href="/contact"
                    className="product-btn product-btn-primary"
                  >
                    Get Started
                  </a>
                  {/* <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-outline"
                  >
                    See how it works
                  </a> */}
                </motion.div>
              </motion.div>

              <motion.div
                variants={parentVariants}
                initial="hidden"
                animate="show"
                style={{ flex: 1, width: "100%" }}
              >
                <VerifyXHeroArt />
              </motion.div>
            </div>
          </div>
        </section>

        {/* 2. PLATFORM FEATURES (Mapped correctly to 9 provided items) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">Platform</span>
              <h2 className="gen-h2">Unified Verification Platform</h2>
              <p className="gen-h2-sub">
                Everything banks, vendors, and field teams need in one place.
              </p>
              <p
                className="gen-h2-sub"
                style={{ marginTop: "1.2rem", fontSize: "1.4rem" }}
              >
                One system to manage Technical, Legal, CPV, and CPD cases
                end-to-end · Connects banks, vendors, and field teams in a
                single workspace.
              </p>
            </motion.div>

            <motion.div
              className="product-grid-3"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div className="product-card" variants={childVariants}>
                <div className="product-icon-box">
                  <Icons.Workflow />
                </div>
                <h3 className="product-card-title">
                  End-to-End Workflow Management
                </h3>
                <ul className="product-feature-list">
                  <li>
                    <Icons.Check /> Full case lifecycle tracking (initiation
                    &rarr; closure)
                  </li>
                  <li>
                    <Icons.Check /> Smart case assignment engine
                  </li>
                  <li>
                    <Icons.Check /> Multi-level approval workflows
                  </li>
                  <li>
                    <Icons.Check /> Bulk case creation for high volumes
                  </li>
                </ul>
              </motion.div>

              <motion.div
                className="product-card hover-glow-blue"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#eff6ff",
                    color: "#3b82f6",
                    borderColor: "#dbeafe",
                  }}
                >
                  <Icons.Visibility />
                </div>
                <h3 className="product-card-title">
                  Real-Time Visibility & Analytics
                </h3>
                <ul className="product-feature-list">
                  <li>
                    <Icons.Check /> Live dashboards for case status & team
                    performance
                  </li>
                  <li>
                    <Icons.Check /> SLA tracking at every stage
                  </li>
                  <li>
                    <Icons.Check /> Detailed reports and audit-ready analytics
                  </li>
                </ul>
              </motion.div>

              <motion.div
                className="product-card hover-glow-purple"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#faf5ff",
                    color: "#a855f7",
                    borderColor: "#f3e8ff",
                  }}
                >
                  <Icons.AI />
                </div>
                <h3 className="product-card-title">AI-Powered Automation</h3>
                <ul className="product-feature-list">
                  <li>
                    <Icons.Check /> OCR-based auto data extraction from
                    documents
                  </li>
                  <li>
                    <Icons.Check /> AI-driven document validation & risk
                    detection
                  </li>
                  <li>
                    <Icons.Check /> Built-in AI ecosystem via Doql marketplace
                  </li>
                </ul>
              </motion.div>

              <motion.div
                className="product-card hover-glow-emerald"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#ecfdf5",
                    color: "#10b981",
                    borderColor: "#d1fae5",
                  }}
                >
                  <Icons.Mobile />
                </div>
                <h3 className="product-card-title">
                  Mobile-First Field Operations
                </h3>
                <ul className="product-feature-list">
                  <li>
                    <Icons.Check /> Field agents receive and manage tasks on
                    mobile
                  </li>
                  <li>
                    <Icons.Check /> Real-time capture of photos, documents,
                    verification data
                  </li>
                  <li>
                    <Icons.Check /> Geo-tagging & timestamp for audit integrity
                  </li>
                  <li>
                    <Icons.Check /> Instant sync with backend systems
                  </li>
                </ul>
              </motion.div>

              <motion.div
                className="product-card hover-glow-orange"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fffbeb",
                    color: "#f59e0b",
                    borderColor: "#fef3c7",
                  }}
                >
                  <Icons.SLA />
                </div>
                <h3 className="product-card-title">SLA & Turnaround Control</h3>
                <ul className="product-feature-list">
                  <li>
                    <Icons.Check /> Define SLAs for each case type
                  </li>
                  <li>
                    <Icons.Check /> Stage-level time tracking
                  </li>
                  <li>
                    <Icons.Check /> Real-time alerts for delays
                  </li>
                  <li>
                    <Icons.Check /> Bottleneck identification across
                    teams/vendors
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div
                  className="product-icon-box"
                  style={{
                    background: "#e0f2fe",
                    color: "#0ea5e9",
                    borderColor: "#bae6fd",
                  }}
                >
                  <Icons.Collab />
                </div>
                <h3 className="product-card-title">
                  Vendor & Team Collaboration
                </h3>
                <ul className="product-feature-list">
                  <li>
                    <Icons.Check /> Seamless integration of internal teams +
                    external vendors
                  </li>
                  <li>
                    <Icons.Check /> Centralized management of users and
                    workflows
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fdf2f8",
                    color: "#ec4899",
                    borderColor: "#fce7f3",
                  }}
                >
                  <Icons.Lock />
                </div>
                <h3 className="product-card-title">Compliance & Security</h3>
                <ul className="product-feature-list">
                  <li>
                    <Icons.Check /> DPDPA-ready data protection framework
                  </li>
                  <li>
                    <Icons.Check /> Consent management system
                  </li>
                  <li>
                    <Icons.Check /> Full audit logs and activity tracking
                  </li>
                  <li>
                    <Icons.Check /> Multi-tenant secure architecture
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fee2e2",
                    color: "#ef4444",
                    borderColor: "#fecaca",
                  }}
                >
                  <Icons.Risk />
                </div>
                <h3 className="product-card-title">Risk & NPA Reduction</h3>
                <ul className="product-feature-list">
                  <li>
                    <Icons.Check /> Structured verification workflows
                  </li>
                  <li>
                    <Icons.Check /> AI-driven accuracy and reduced manual errors
                  </li>
                  <li>
                    <Icons.Check /> SLA-driven timely processing
                  </li>
                  <li>
                    <Icons.Check /> Complete audit trail for better credit
                    decisions
                  </li>
                </ul>
              </motion.div>

              <motion.div className="product-card" variants={childVariants}>
                <div
                  className="product-icon-box"
                  style={{
                    background: "#dcfce7",
                    color: "#22c55e",
                    borderColor: "#bbf7d0",
                  }}
                >
                  <Icons.Impact />
                </div>
                <h3 className="product-card-title">Business Impact</h3>
                <ul className="product-feature-list">
                  <li>
                    <Icons.Check /> Up to 50% faster turnaround time
                  </li>
                  <li>
                    <Icons.Check /> Improved SLA adherence
                  </li>
                  <li>
                    <Icons.Check /> Reduced operational costs
                  </li>
                  <li>
                    <Icons.Check /> Lower default (NPA) risk
                  </li>
                </ul>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 3. TRUSTED BY STATS */}
        <section
          className="product-section product-section-alt"
          style={{ padding: "6.4rem 0" }}
        >
          <div className="sec-container">
            <p className="product-strip-label">
              Trusted by leading banks and verification agencies
            </p>
            <div className="product-stats-strip">
              <div className={styles["product-stat-item"]}>
                <p className="product-stat-num">50+</p>
                <p className={styles["product-stat-text"]}>Banking Partners</p>
              </div>
              <div className={styles["product-stat-item"]}>
                <p className="product-stat-num">200+</p>
                <p className={styles["product-stat-text"]}>Vendor Networks</p>
              </div>
              <div className={styles["product-stat-item"]}>
                <p className="product-stat-num">1M+</p>
                <p className={styles["product-stat-text"]}>Cases Processed</p>
              </div>
              <div className={styles["product-stat-item"]}>
                <p className="product-stat-num">99.9%</p>
                <p className={styles["product-stat-text"]}>Uptime SLA</p>
              </div>
            </div>
          </div>
        </section>

        {/* 4. WHY VERIFYX (Bento Grid) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">Why VerifyX</span>
              <h2 className="gen-h2">Everything You Need in One Platform</h2>
              <p className="gen-h2-sub">
                One workspace for banks, vendors, and field teams: end-to-end
                cases, AI-assisted verification, SLA control—stronger decisions,
                lower NPA exposure.
              </p>
            </motion.div>

            <motion.div
              className="product-grid-4"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div
                className="product-card hover-inset"
                style={{ alignItems: "center", textAlign: "center" }}
                variants={childVariants}
              >
                <div className="product-icon-box">
                  <Icons.Workflow />
                </div>
                <h3 className="product-card-title">Unified Workflows</h3>
                <p className="product-card-desc">CPV, CPD, Technical & Legal</p>
              </motion.div>
              <motion.div
                className="product-card hover-inset"
                style={{ alignItems: "center", textAlign: "center" }}
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#eff6ff",
                    color: "#3b82f6",
                    borderColor: "#dbeafe",
                  }}
                >
                  <Icons.Visibility />
                </div>
                <h3 className="product-card-title">AI + OCR + SLA</h3>
                <p className="product-card-desc">
                  Visibility & real-time analytics
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-inset"
                style={{ alignItems: "center", textAlign: "center" }}
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#ecfdf5",
                    color: "#10b981",
                    borderColor: "#d1fae5",
                  }}
                >
                  <Icons.Mobile />
                </div>
                <h3 className="product-card-title">Mobile Field Capture</h3>
                <p className="product-card-desc">Vendor collaboration</p>
              </motion.div>
              <motion.div
                className="product-card hover-inset"
                style={{ alignItems: "center", textAlign: "center" }}
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fdf2f8",
                    color: "#ec4899",
                    borderColor: "#fce7f3",
                  }}
                >
                  <Icons.Lock />
                </div>
                <h3 className="product-card-title">DPDPA-Ready</h3>
                <p className="product-card-desc">
                  Full audit trail to support lower NPA risk
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 5. HOW IT WORKS */}
        <section
          className="product-section product-section-alt"
          id="how-it-works"
        >
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">How It Works</span>
              <h2 className="gen-h2">Up and Running in Three Steps</h2>
            </motion.div>

            <motion.div
              className="product-step-wrapper"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <div className="product-step-line" />
              <div className="product-grid-3">
                <motion.div className="product-step" variants={childVariants}>
                  <div className="product-step-icon-wrap">
                    <div className="product-step-icon-bg" />
                    <div className="product-step-icon">
                      <Icons.User />
                    </div>
                    <div className="product-step-num">1</div>
                  </div>
                  <h3 className="product-card-title">Onboard in Minutes</h3>
                  <p className="product-card-desc">
                    Banks and vendors register, set up profiles, branches, and
                    users through a guided flow.
                  </p>
                </motion.div>
                <motion.div className="product-step" variants={childVariants}>
                  <div className="product-step-icon-wrap">
                    <div className="product-step-icon-bg" />
                    <div className="product-step-icon">
                      <Icons.Clipboard />
                    </div>
                    <div className="product-step-num">2</div>
                  </div>
                  <h3 className="product-card-title">Create & Assign Cases</h3>
                  <p className="product-card-desc">
                    Create Technical, Legal, CPV or CPD requests. Assign to
                    drafters or vendors instantly.
                  </p>
                </motion.div>
                <motion.div className="product-step" variants={childVariants}>
                  <div className="product-step-icon-wrap">
                    <div className="product-step-icon-bg" />
                    <div className="product-step-icon">
                      <Icons.Shield />
                    </div>
                    <div className="product-step-num">3</div>
                  </div>
                  <h3 className="product-card-title">
                    Review, Approve & Stay Compliant
                  </h3>
                  <p className="product-card-desc">
                    Multi-level approvals, e-sign, and built-in compliance keep
                    everything audit-ready.
                  </p>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* 6. VERIFYX AI CHATBOT BLOCK */}
        <section className="product-section">
          <div className="sec-container">
            <div className={`${styles["product-chat-block"]} hover-glow-blue`}>
              <div className={styles["product-chat-ui"]}>
                <div className={styles["product-chat-header"]}>
                  <div className={styles["product-chat-avatar"]}>
                    <Icons.AI />
                  </div>
                  <div>
                    <h4
                      style={{
                        color: "white",
                        margin: 0,
                        fontSize: "1.6rem",
                        fontWeight: 700,
                      }}
                    >
                      VerifyX AI
                    </h4>
                    <p
                      style={{
                        color: "#bae6fd",
                        margin: 0,
                        fontSize: "1.2rem",
                      }}
                    >
                      24/7 Support
                    </p>
                  </div>
                </div>
                <div className={styles["product-chat-body"]}>
                  <div
                    className={`${styles["chat-bubble"]} ${styles["receive"]}`}
                  >
                    Hi! Welcome to VerifyX AI. How can I assist you today?
                  </div>
                  <div className={`${styles["chat-bubble"]} ${styles["send"]}`}>
                    I want to check my service request status
                  </div>
                  <div
                    className={`${styles["chat-bubble"]} ${styles["receive"]}`}
                  >
                    Sure! You have 3 active service requests. SR-1042 is under
                    review, SR-1038 is approved, and SR-1045 is awaiting
                    assignment. Would you like details on any of these?
                  </div>
                </div>
                <div className={styles["product-chat-input"]}>
                  <div
                    className={styles["product-chat-field"]}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#94a3b8",
                    }}
                    aria-hidden
                  >
                    Ask VerifyX AI anything...
                  </div>
                  <div
                    className={styles["product-chat-send"]}
                    style={{ borderRadius: "1.2rem" }}
                    aria-hidden
                  >
                    <Icons.ArrowRight />
                  </div>
                </div>
              </div>
              <div className={styles["product-chat-text"]}>
                <span className="product-eyebrow">AI-Powered Assistant</span>
                <h2
                  className="product-h1"
                  style={{ color: "white", fontSize: "3.6rem" }}
                >
                  Meet VerifyX AI,
                  <br />
                  Your Smart Copilot
                </h2>
                <p className="product-lead" style={{ color: "#94a3b8" }}>
                  An intelligent chatbot built into every panel. Get instant
                  answers, create service requests, check statuses, and navigate
                  the platform — all through natural conversation.
                </p>
                <ul
                  className="product-feature-list"
                  style={{ color: "#cbd5e1", marginBottom: "3.2rem" }}
                >
                  <li>
                    <Icons.Check /> Available in both Vendor and Banker panels
                  </li>
                  <li>
                    <Icons.Check /> Context-aware responses powered by LLM
                  </li>
                  <li>
                    <Icons.Check /> Quick-action cards for common workflows
                  </li>
                  <li>
                    <Icons.Check /> Full conversation history within sessions
                  </li>
                </ul>
                <a
                  href="/api-catalogue-home"
                  className="product-btn product-btn-primary"
                  style={{ alignSelf: "flex-start" }}
                >
                  Try VerifyX AI
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* 7. AUDIENCE (Split) */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">
                Built for Both Sides
              </span>
              <h2 className="gen-h2">One Platform, Two Experiences</h2>
            </motion.div>

            <div className="product-grid-2">
              <div className={`${styles["product-split-card"]} hover-lift-lg`}>
                <img
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80"
                  alt="Vendor Dashboard"
                  className={styles["product-split-img"]}
                  loading="lazy"
                />
                <div className={styles["product-split-content"]}>
                  <span
                    className="product-section-eyebrow"
                    style={{
                      backgroundColor: "#ecfdf5",
                      color: "#10b981",
                      borderColor: "#a7f3d0",
                    }}
                  >
                    For Vendors
                  </span>
                  <h3 className="gen-h2" style={{ fontSize: "2.8rem" }}>
                    Streamline Field Operations
                  </h3>
                  <p className="gen-h2-sub" style={{ marginBottom: "2.4rem" }}>
                    One dashboard for every banking partner. Manage onboarding,
                    branches, case assignments, and documents from a single
                    login.
                  </p>
                  <ul
                    className="product-feature-list"
                    style={{ marginBottom: "3.2rem" }}
                  >
                    <li>
                      <Icons.Check /> Multi-bank assignments in one view
                    </li>
                    <li>
                      <Icons.Check /> Branch & document management
                    </li>
                    <li>
                      <Icons.Check /> Real-time task tracking & SLA alerts
                    </li>
                  </ul>
                  <a
                    href="#vendors"
                    className="product-btn product-btn-light-outline"
                  >
                    Explore Vendor Features &rarr;
                  </a>
                </div>
              </div>

              <div className={`${styles["product-split-card"]} hover-lift-lg`}>
                <img
                  src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&q=80"
                  alt="Banker Dashboard"
                  className={styles["product-split-img"]}
                  loading="lazy"
                />
                <div className={styles["product-split-content"]}>
                  <span
                    className="product-section-eyebrow"
                    style={{
                      backgroundColor: "#eff6ff",
                      color: "#3b82f6",
                      borderColor: "#bfdbfe",
                    }}
                  >
                    For Bankers
                  </span>
                  <h3 className="gen-h2" style={{ fontSize: "2.8rem" }}>
                    Full Verification Control
                  </h3>
                  <p className="gen-h2-sub" style={{ marginBottom: "2.4rem" }}>
                    End-to-end case management with role-based workflows,
                    multi-level approvals, and a built-in compliance center.
                  </p>
                  <ul
                    className="product-feature-list"
                    style={{ marginBottom: "3.2rem" }}
                  >
                    <li>
                      <Icons.Check /> Case creation to closure in one flow
                    </li>
                    <li>
                      <Icons.Check /> Multi-level approval workflows
                    </li>
                    <li>
                      <Icons.Check /> DPDPA-ready compliance center
                    </li>
                  </ul>
                  <a
                    href="#bankers"
                    className="product-btn product-btn-light-outline"
                  >
                    Explore Banking Features &rarr;
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 8. AI SUITE (4 Cards) */}
        <section className="product-section">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">AI Suite</span>
              <h2 className="gen-h2">Built-in AI, zero bolt-ons</h2>
              <p className="gen-h2-sub">
                DokGen, Billing, voice capture, and VerifyX AI Bot ship with
                every panel—then extend deeper with Doql.
              </p>
            </motion.div>

            <motion.div
              className="product-grid-4"
              variants={parentVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
            >
              <motion.div className="product-card" variants={childVariants}>
                <div className="product-icon-box">
                  <Icons.Document />
                </div>
                <h3 className="product-card-title">DokGen</h3>
                <p
                  className="product-card-desc"
                  style={{
                    color: "#4f46e5",
                    fontWeight: 600,
                    marginBottom: "0.8rem",
                  }}
                >
                  AI Document Generation
                </p>
                <p className="product-card-desc">
                  Automatically generate verification reports, legal documents,
                  and compliance paperwork. Reduce drafting time from hours to
                  minutes.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-blue"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#eff6ff",
                    color: "#3b82f6",
                    borderColor: "#dbeafe",
                  }}
                >
                  <Icons.PieChart />
                </div>
                <h3 className="product-card-title">Billing</h3>
                <p
                  className="product-card-desc"
                  style={{
                    color: "#3b82f6",
                    fontWeight: 600,
                    marginBottom: "0.8rem",
                  }}
                >
                  Smart Invoicing & Payments
                </p>
                <p className="product-card-desc">
                  AI-powered billing that auto-calculates fees based on service
                  type, vendor rates, and SLA terms. Reconcile payments and
                  generate invoices instantly.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-purple"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#faf5ff",
                    color: "#a855f7",
                    borderColor: "#f3e8ff",
                  }}
                >
                  <Icons.Mic />
                </div>
                <h3 className="product-card-title">Speech To Text</h3>
                <p
                  className="product-card-desc"
                  style={{
                    color: "#a855f7",
                    fontWeight: 600,
                    marginBottom: "0.8rem",
                  }}
                >
                  Voice-Powered Input
                </p>
                <p className="product-card-desc">
                  Dictate field notes, case updates, and observations on the go.
                  Accurate transcription converts voice to structured data ready
                  for reports.
                </p>
              </motion.div>
              <motion.div
                className="product-card hover-glow-orange"
                variants={childVariants}
              >
                <div
                  className="product-icon-box"
                  style={{
                    background: "#fffbeb",
                    color: "#f59e0b",
                    borderColor: "#fef3c7",
                  }}
                >
                  <Icons.AI />
                </div>
                <h3 className="product-card-title">VerifyX AI Bot</h3>
                <p
                  className="product-card-desc"
                  style={{
                    color: "#f59e0b",
                    fontWeight: 600,
                    marginBottom: "0.8rem",
                  }}
                >
                  Intelligent Assistant
                </p>
                <p className="product-card-desc">
                  Natural language chatbot embedded in every panel. Create
                  requests, check statuses, pull reports, and navigate the
                  platform through conversation.
                </p>
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* 9. COMPLIANCE CENTER */}
        <section className="product-section product-section-alt">
          <div className="sec-container">
            <motion.div
              className="product-section-head"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              variants={childVariants}
            >
              <span className="product-section-eyebrow">Compliance Center</span>
              <h2 className="gen-h2">
                Manage Policies, Certifications & Compliance Monitoring
              </h2>
              <p className="gen-h2-sub">
                A dedicated hub for consent management, DPDPA compliance, data
                policies, and audit trails — everything you need to stay
                audit-ready and regulation-compliant.
              </p>
            </motion.div>

            <div className="product-comp-grid">
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">98%</p>
                <p className="product-comp-label">Compliance Score</p>
                <p
                  className="product-card-desc"
                  style={{ fontSize: "1.2rem", marginTop: "0.8rem" }}
                >
                  DPDPA Compliance
                </p>
              </div>
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">99.99%</p>
                <p className="product-comp-label">Availability</p>
                <p
                  className="product-card-desc"
                  style={{ fontSize: "1.2rem", marginTop: "0.8rem" }}
                >
                  Data Policy
                </p>
              </div>
              <div className="product-comp-card hover-scale">
                <p className="product-comp-val">24/7</p>
                <p className="product-comp-label">Monitoring</p>
                <p
                  className="product-card-desc"
                  style={{ fontSize: "1.2rem", marginTop: "0.8rem" }}
                >
                  Activity Log
                </p>
              </div>
              <div
                className="product-comp-card hover-scale"
                style={{ gridColumn: "span 1" }}
              >
                <p className="product-comp-val">Real-time</p>
                <p className="product-comp-label">Tracking</p>
                <p
                  className="product-card-desc"
                  style={{ fontSize: "1.2rem", marginTop: "0.8rem" }}
                >
                  Access Log
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* 10. FINAL CTA (DARK) */}
        <section className="product-dark-cta">
          <div className="product-hero-ambient" />
          <div className="sec-container">
            <div
              className="product-cta-grid"
              style={{ gridTemplateColumns: "1fr", textAlign: "center" }}
            >
              <div style={{ maxWidth: "80rem", margin: "0 auto" }}>
                <h2 className="product-h1" style={{ fontSize: "4.8rem" }}>
                  Streamline verification.
                  <br />
                  <span className="product-text-gradient">
                    Scale with confidence.
                  </span>
                </h2>
                <p className="product-lead" style={{ marginBottom: "4rem" }}>
                  Join the banks and vendors already using VerifyX to manage
                  cases, stay compliant, and move faster — all from one
                  platform.
                </p>
                <div
                  className="product-cta-group"
                  style={{ justifyContent: "center" }}
                >
                  <a
                    href="/api-catalogue-home"
                    className="product-btn product-btn-primary"
                    style={{ padding: "1.6rem 3.2rem" }}
                  >
                    Get Started
                  </a>
                  <a
                    href="/contact"
                    className="product-btn product-btn-outline"
                    style={{ padding: "1.6rem 3.2rem" }}
                  >
                    Request A Demo
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
